module.exports = __webpack_public_path__ + "assets/retina_Equilateral3Detailed.1c3f9c81a868a7c697a18a75a64e0fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Equilateral3Detailed.png
// module id = 662
// module chunks = 0